import React, { useCallback } from 'react'

import TableRowActionWrapper from '../Features/TableRowAction'
import { getTableRowClassString } from '../TableHelper'
import { EMPTY_ROW_ID } from '../util'

const getTableRowProps = (rowProps, cells, style, isResizable, row, emptyBorderRowHeight, tableRowAction) => {
  if (row.id === EMPTY_ROW_ID) {
    style = {
      ...style, height: emptyBorderRowHeight
    };
  }
  if (!isResizable) {
    return { ...rowProps, style: { ...rowProps.style, ...style } }
  }

  //removing width from react window list style to avoid changing cell width on resize
  const { width, ...restWindowListStyle } = style
  let isResizingColumnIndex = cells.findIndex((cell) => cell.column.isResizing)
  if (isResizingColumnIndex >= 0) {
    let columnWidth = 0
    let cellsTotalWidth = cells.map((cell) => {
      columnWidth += cell.column.width
      return columnWidth
    })
    return {
      ...rowProps,
      style: { display: 'flex', width: cellsTotalWidth + 'px', ...restWindowListStyle }
    }
  }
  if (!tableRowAction) {
    return { ...rowProps, style: { ...rowProps.style, width, ...restWindowListStyle } }
  }
  return { ...rowProps, style: { ...rowProps.style, ...restWindowListStyle } }
}

const TableRow = (props) => {
  const {
    row,
    isRowDisabled,
    rowSelectCheckboxProp,
    viewBy,
    isSingleRowSelected,
    equalWidthColumns,
    rowDisableProp,
    handleRowClick,
    style,
    isResizable,
    rowActionData,
    updateRowActionData,
    tableRowActionList = [],
    totalCounts,
    showEmptyBorder,
    emptyBorderRowHeight,
    v2Features,
    actionsLayoutTestId,
    actionsListTestId
  } = props

  const TableRowActionComponent = useCallback(() => {
    return (
      rowActionData.rowIndex === row.index &&
      tableRowActionList.length > 0 && (
        <TableRowActionWrapper
          list={tableRowActionList}
          data={row.original}
          rowActionData={rowActionData}
          viewBy={viewBy}
          closeDropdown={() => {
            updateRowActionData({ rowIndex: -1 })
          }}
          actionsLayoutTestId={actionsLayoutTestId}
          actionsListTestId={actionsListTestId}
        />
      )
    )
  }, [rowActionData])


  return (
    <div
      {...getTableRowProps(row.getRowProps(), row.cells, style, isResizable, row, emptyBorderRowHeight, v2Features.tableRowAction)}
      className={`${getTableRowClassString(
        row,
        isRowDisabled,
        rowSelectCheckboxProp,
        viewBy,
        isSingleRowSelected,
        equalWidthColumns,
        rowDisableProp
      )} ${rowActionData.rowIndex === row.index ? 'Table__row_action-selected' : ''}
        ${props.v2Features.tableRowAction ? 'Table__body__row_action' : ''}
        ${showEmptyBorder && row.id === "empty_row" ? 'Table__empty__row' : ''}
        `}
      onClick={(e) => {
        if (row.id !== EMPTY_ROW_ID) {
          handleRowClick(e, isRowDisabled, row)
        }
      }}
      key={row.id}
      data-test-id={`cs-table-body-row-${row.index}`}
      tabIndex={row.id === EMPTY_ROW_ID ? -1 : 0}
      aria-label={`row ${row.index + 1}`}
      onKeyDown={(e: any) => {
        if (e.key === 'Enter' && rowActionData.rowIndex !== row.index) {
          handleRowClick(e, isRowDisabled, row)
          return
        }
      }}>

      {props.children}

      {TableRowActionComponent()}
    </div>
  )
}

export default TableRow
